/*
 * inselvolt Kompatibilitätsberater — redaktionelle Praxis-Hinweise.
 *
 * BEWUSST GETRENNT von berater-daten.js: Dort steht ausschließlich, was ein
 * Herstellerdokument belegt. Hier steht Erfahrungswissen von inselvolt, für das
 * es KEINEN Herstellerbeleg gibt — es darf deshalb niemals als Freigabe, als
 * Datenblattwert oder als Herstelleraussage erscheinen. Die UI kennzeichnet jeden
 * dieser Texte sichtbar als inselvolt-Hinweis und stellt ihn nie neben die
 * Quellenangaben der Freigaben.
 *
 * Warum es sie trotzdem gibt: Die Frage „kann ich meinen Speicher erweitern?"
 * beantwortet die Whitelist nur zur Hälfte (welche Ausbaustufe ist freigegeben).
 * Die andere Hälfte — worauf beim Nachrüsten zu achten ist — steht in
 * Installationshandbüchern, die hier nicht vorliegen. Statt die Frage offen zu
 * lassen, geben wir allgemeine Hinweise und benennen ihre Herkunft.
 *
 * Pflege: Diese Datei ist KEIN Datenpflege-Fall nach DATENPFLEGE.md (Rezepte A–G)
 * — sie enthält keine Datenblattwerte. Änderungen brauchen aber dieselbe Sorgfalt:
 * keine Aussage, die ein Hersteller widerlegen könnte, kein „immer"/„nie" ohne Not,
 * und immer der Verweis auf das verbindliche Gerätehandbuch.
 *
 * freigabe_status: 'entwurf' ⇒ Texte sind fachlich noch nicht von inselvolt
 * abgenommen. Vor einem Livegang auf 'freigegeben' setzen.
 */
(function (root) {
  'use strict';

  var HINWEISE = {
    urheber: 'inselvolt',
    stand: '2026-07-29',
    // Von inselvolt fachlich abgenommen am 2026-08-09 (Texte unverändert).
    freigabe_status: 'freigegeben',
    // Label, das die UI an jeden dieser Blöcke schreibt — nie leer lassen.
    kennzeichnung: 'Hinweis von inselvolt. Erfahrungswert, kein Herstellerbeleg.',
    verbindlichkeit: 'Verbindlich ist immer das Handbuch Ihres Geräts und die Auskunft Ihres Installateurs.',

    /*
     * Zubehör: Was außer dem Speicher nötig ist, damit die Anlage tut, was der
     * Kunde erwartet. KEIN Herstellerbeleg — die Freigabelisten sagen nichts
     * über Zähler oder Notstromumschaltung, und die Datenbasis führt beides
     * nicht. Deshalb bewusst allgemein gehalten und ohne Produktnennung: Was
     * konkret nötig ist, hängt am Wechselrichter und an der Hausinstallation.
     *
     * Ausnahme, die NICHT hier steht: die kostenpflichtigen KOSTAL-
     * Freischaltungen. Die sind belegt (PLENTICOIN-Factsheet) und stehen mit
     * Anzahl und Quelle in berater-daten.js — sie erscheinen getrennt von
     * diesem Block, damit ein Erfahrungswert nie wie eine Herstellerangabe
     * aussieht.
     */
    zubehoer: {
      titel: 'Woran Sie außerdem denken sollten',
      einleitung: 'Der Speicher allein genügt selten. Je nach Wechselrichter und '
        + 'Hausanschluss kommt Folgendes dazu:',
      punkte: [
        'Ein Energiezähler am Netzanschluss (Smart Meter). Ohne ihn weiß der '
          + 'Wechselrichter nicht, wie viel gerade verbraucht wird. Er lädt oder '
          + 'entlädt am Bedarf vorbei. Welcher Zähler passt, gibt der '
          + 'Wechselrichter-Hersteller vor.',
        'Eine Umschalteinrichtung, wenn das Haus bei Netzausfall weiterlaufen soll '
          + '(Backup-Box, Notstromumschaltung). Ersatzstrom ist kein Zubehör, das man '
          + 'später einfach ansteckt. Er will von Anfang an mitgeplant werden.',
        'Bei manchen Wechselrichtern ist der Batterieeingang kostenpflichtig '
          + 'freizuschalten. Wo uns das belegt vorliegt, weisen wir es oben direkt '
          + 'an Ihrer Kombination aus.',
        'Leitungswege und Aufstellort: Hochvolt-Speicher haben Vorgaben zu '
          + 'Temperatur, Abstand und Leitungslänge zum Wechselrichter.',
      ],
    },

    erweiterung: {
      im_selben_turm: {
        titel: 'Module im vorhandenen Turm ergänzen',
        einleitung: 'Ob Ihr installierter Turm nachträglich um Module erweitert werden kann, '
          + 'hängt vom Gerät und vom Zustand der vorhandenen Module ab. Das steht nicht in den '
          + 'Freigabelisten, sondern im Installationshandbuch. Diese Punkte entscheiden erfahrungsgemäß:',
        punkte: [
          'Baugleichheit: Ergänzt werden können in aller Regel nur Module derselben Baureihe. '
            + 'Ein Mischbetrieb verschiedener Modultypen oder Gerätegenerationen ist meist ausgeschlossen.',
          'Alter und Ladezustand: Alte und neue Module altern unterschiedlich. Hersteller nennen '
            + 'dafür häufig ein Zeitfenster nach Erstinbetriebnahme und einen Angleich-Vorgang, '
            + 'bevor die Erweiterung freigegeben ist.',
          'Firmware: Speicher und Wechselrichter müssen die in der Freigabeliste genannten '
            + 'Mindeststände erreichen. Bei der Kombination oben sehen Sie, welche das sind.',
          'Konfiguration danach: Die neue Modulanzahl muss im Wechselrichter hinterlegt werden, '
            + 'sonst rechnet das System mit der alten Kapazität.',
          'Ausführung: Arbeiten an der Hochvolt-Batterie gehören in die Hand eines Fachbetriebs. '
            + 'Eigenmächtige Eingriffe können Gewährleistung und Herstellergarantie kosten.',
        ],
      },

      zweiter_turm: {
        titel: 'Einen zweiten Speicherturm ergänzen',
        einleitung: 'Reicht der maximale Ausbau eines Turms nicht, kommt ein zweiter Turm parallel '
          + 'in Frage. Ob Ihr Wechselrichter das unterstützt, steht in der Freigabeliste. Wo wir '
          + 'eine Angabe dazu haben, finden Sie sie oben bei der Kombination. Zusätzlich gilt:',
        punkte: [
          'Nicht jeder Wechselrichter kann mehrere Batterietürme führen. Manche Listen begrenzen '
            + 'ausdrücklich auf einen Turm. Dann ist der zweite Turm keine Option, sondern ein '
            + 'anderer Wechselrichter.',
          'Türme müssen üblicherweise gleich aufgebaut sein (gleiche Baureihe, gleiche Modulanzahl).',
          'Für den Parallelbetrieb schreiben Hersteller teils Zusatzkomponenten vor, etwa eine '
            + 'Combiner Box, und begrenzen die zulässigen Ströme. Beides beeinflusst die Installation.',
          'Mehr Kapazität heißt nicht automatisch mehr Leistung: Die Lade- und Entladeleistung wird '
            + 'weiterhin vom kleineren der beiden Werte begrenzt, häufig vom Wechselrichter. '
            + 'Der Berater weist oben aus, wer die Grenze setzt.',
          'Alternative bei ausgereiztem Wechselrichter: ein zweiter, AC-gekoppelter Speicher mit '
            + 'eigenem Wechselrichter. Das ist ein anderer Anlagenaufbau und will separat gerechnet werden.',
        ],
      },

      nutzen: {
        titel: 'Lohnt sich mehr Kapazität?',
        einleitung: 'Zusätzliche Kapazität zahlt sich nur aus, wenn sie im Jahresverlauf auch '
          + 'gefüllt und wieder geleert wird. Als Orientierung:',
        punkte: [
          'Ein Speicher, der im Sommer regelmäßig voll wird und morgens leer ist, ist ausgelastet. '
            + 'Hier bringt eine Erweiterung am ehesten etwas.',
          'Bleibt der Speicher auch an guten Tagen halb voll, fehlt es an Verbrauch oder an '
            + 'Erzeugung, nicht an Kapazität.',
          'Wärmepumpe, Wallbox oder ein dynamischer Stromtarif erhöhen den sinnvoll nutzbaren '
            + 'Speicherbedarf deutlich.',
          'Wir rechnen das auf Wunsch mit Ihren Verbrauchsdaten durch, statt es zu schätzen.',
        ],
      },
    },
  };

  if (typeof module !== 'undefined' && module.exports) module.exports = HINWEISE;
  if (root) root.IVBeraterHinweise = HINWEISE;
})(typeof window !== 'undefined' ? window : null);
